import { render } from "./AddMoreTyres.vue?vue&type=template&id=e360bb86"
import script from "./AddMoreTyres.vue?vue&type=script&lang=js"
export * from "./AddMoreTyres.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__